<script setup lang="ts"></script>

<template>
  <PageContainerAlignment
    class="gap-r12 xl:gap-r18 py-r12 xl:py-r18 relative flex flex-col items-start justify-between lg:flex-row lg:items-center"
  >
    <ServicesRelaxSolariumImage />
    <ServicesRelaxSolariumHeader />
  </PageContainerAlignment>
</template>
